import React, { useEffect } from 'react';
import MainPage from './pages/MainPage';
import { Analytics } from '@vercel/analytics/react';
import { AnalyticsWrapper } from './components/AnalyticsWrapper';

function App() {
  useEffect(() => {
    // Silently handle orientation lock
    try {
      if (window.screen && window.screen.orientation && window.screen.orientation.lock) {
        window.screen.orientation.lock('portrait')
          .catch(() => {
            // Silently ignore orientation lock errors
          });
      }
    } catch (error) {
      // Silently ignore any errors
    }
  }, []);

  return (
    <>
      <MainPage />
      <AnalyticsWrapper />
    </>
  );
}

export default App;